import { endOfDay, isSameDay, startOfDay } from "date-fns";

export const getMinAndMaxTime = (
  selectedDate?: Date,
  minDate?: Date,
  maxDate?: Date,
) => {
  if (
    selectedDate &&
    minDate &&
    maxDate &&
    isSameDay(selectedDate, minDate) &&
    isSameDay(selectedDate, maxDate)
  ) {
    return { minTime: minDate, maxTime: maxDate };
  }

  if (selectedDate && minDate && isSameDay(selectedDate, minDate)) {
    return { minTime: minDate, maxTime: endOfDay(minDate) };
  }

  if (selectedDate && maxDate && isSameDay(selectedDate, maxDate)) {
    return { minTime: startOfDay(maxDate), maxTime: maxDate };
  }

  return { minTime: undefined, maxTime: undefined };
};
